import { DefaultSeoProps } from "next-seo"

export const ArSEO: DefaultSeoProps = {
    title: "باس تيكيتس",
    titleTemplate: "%s | باس تيكيتس",
    description:
        "منصة متكاملة لبيع التذاكر و إنشاء الفعاليات في أي مجال تتخيله؛ سواء كان رياضيًا، ثقافيًا، سياحيًا، اجتماعيًا، تعليميًا، موسيقيًا، ترفيهيًا.",
    openGraph: {
        type: "website",
        locale: "ar_SA",
        url: "https://pass-tickets.com",
        site_name: "باس تيكيتس",
        images: [
            {
                url: "https://passticketscdn.azureedge.net/frontend/hero.png",
                alt: "PassTickets",
                type: "image/png",
                height: 600,
                width: 800,
            },
            {
                url: "https://passticketscdn.azureedge.net/frontend/hero2.png",
                type: "image/png",
                alt: "PassTickets",
                height: 600,
                width: 800,
            },
        ],
    },
    languageAlternates: [
        {
            hrefLang: "x-default",
            href: "https://pass-tickets.com",
        },
        {
            hrefLang: "ar",
            href: "https://pass-tickets.com",
        },
        {
            hrefLang: "en",
            href: "https://pass-tickets.com/en-US",
        },
    ],
    canonical:
        process.env.NEXT_PUBLIC_SITE_URL || "https://pass-tickets.com",
    twitter: {
        cardType: "summary_large_image",
        handle: "@PassTickets",
        site: "@PassTickets",
    },
    additionalMetaTags: [
        {
            name: "viewport",
            content: "width=device-width, initial-scale=1",
        },
        {
            name: "theme-color",
            content: "#ffffff",
        },
        {
            name: "application-name",
            content: "باس تيكيتس",
        },
    ],
}

export const EnSEO: DefaultSeoProps = {
    title: "PassTickets",
    titleTemplate: "%s | PassTickets",
    description:
        "A complete platform for selling tickets and creating events in any field you can imagine; Whether it is sports, cultural, tourist, social, educational, musical, entertainment.",
    openGraph: {
        type: "website",
        locale: "en_US",
        url: "https://pass-tickets.com/en-US",
        site_name: "PassTickets",
        images: [
            {
                url: "https://passticketscdn.azureedge.net/frontend/hero.png",
                alt: "PassTickets",
                type: "image/png",
                height: 600,
                width: 800,
            },
            {
                url: "https://passticketscdn.azureedge.net/frontend/hero2.png",
                type: "image/png",
                alt: "PassTickets",
                height: 600,
                width: 800,
            },
        ],
    },
    canonical:
        process.env.NEXT_PUBLIC_SITE_URL || "https://pass-tickets.com",
    languageAlternates: [
        {
            hrefLang: "x-default",
            href: "https://pass-tickets.com",
        },
        {
            hrefLang: "ar",
            href: "https://pass-tickets.com",
        },
        {
            hrefLang: "en",
            href: "https://pass-tickets.com/en-US",
        },
    ],
    twitter: {
        cardType: "summary_large_image",
        handle: "@PassTickets",
        site: "@PassTickets",
    },
    additionalMetaTags: [
        {
            name: "viewport",
            content: "width=device-width, initial-scale=1",
        },
        {
            name: "theme-color",
            content: "#ffffff",
        },
        {
            name: "application-name",
            content: "PassTickets",
        },
    ],
}
